
























































































































































































































































































































































































































































































































































































































































    import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
    // @ts-ignore
    import Datepicker from 'vuejs-datepicker';
    import moment from 'moment';
    // @ts-ignore
    import { fr } from 'vuejs-datepicker/dist/locale';
    import chunk from 'lodash/chunk';
    import debounce from 'lodash/debounce';
    import Lightbox from '@/components/Lightbox.vue';
    import Address from '@/components/Address.vue';
    import take from 'lodash/take';
    import concat from 'lodash/concat';
    import takeRight from 'lodash/takeRight';
    import TextEditor from '@/components/TextEditor.vue';
    // @ts-ignore
    import localeDatePicker from 'ant-design-vue/lib/date-picker/locale/fr_FR';
    import { BACKEND_URL } from '@/helpers/constants';
    import compact from 'lodash/compact';
    import uniq from 'lodash/uniq';
    import {
        getCompanyMandat,
        getCompany,
        getProgramMandat,
        getProgram
    } from '../api/api';
    import Company from "@/models/Company";
    import Program from "@/models/Program";
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    // @ts-ignore
    import { quillEditor } from 'vue-quill-editor'
    function isEmpty(value: any) {
        return !value || (typeof value === 'string' && value.trim() === '');
    }

    type TARGET_VIEW = 'list' | 'show';

    @Component({
        components: {
            Datepicker,
            Lightbox,
            Address,
            TextEditor,
            quillEditor,
        },
    })
    export default class Forms extends Vue {
        @Prop() items: any;
        @Prop() firstTabTitle: any;
        @Prop() tabs: any;
        @Prop() title!: string;
        @Prop() headError!: string;
        @Prop() defaultValue!: any | null;
        @Prop({ default: {} }) errors!: any;
        @Prop() type!: 'edit' | 'add';
        @Prop() loading!: boolean;
        @Prop() defaultImages!: any | null;
        @Prop({ type: Boolean, default: false }) hideGoToDetailsButton!: boolean;
        value: any = {};
        images: string | null = null;
        error: any = {};
        valid: boolean = false;
        menu: any = {};
        isSubmit: boolean = false;
        fr = fr;
        containerWidth: number = 0;
        onWindowResizeDebounced = debounce(this.onWindowResize, 300);
        sending: boolean = false;
        targetView: TARGET_VIEW = 'list';
        imageModal: string | null = null;
        BACKEND_URL = BACKEND_URL;
        hasAddressError: boolean = false;
        addressErrors: any = {};
        // option pour quillEditor
        quillOption = {
          placeholder: "Tapper votre signature ici...",
          modules: {
            // personnalisation de la barre d'outils
            toolbar: [
              'bold',
              'italic',
              'underline',
              { 'color': [] },
              { 'background': [] },
              'link',
              'image',
              {'size': ['small',false,'large','huge']},
            ]
          }
        }
        get localeDatePicker() {
            return localeDatePicker;
        }

        async getMandatFile(objet: Program | Company) {

            var name = objet.name.toLowerCase()
                .replace(/\s+/g, '-')           // Replace spaces with -
                .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
                .replace(/\-\-+/g, '-')         // Replace multiple - with single -
                .replace(/^-+/, '')             // Trim - from start of text
                .replace(/-+$/, '');            // Trim - from end of text

            if ((objet as Company).nb_programs !== undefined) {
                getCompanyMandat(objet.id as number).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'mandat_' + name + '.pdf');
                    document.body.appendChild(link);
                    link.click();
                });
            } else {
                getProgramMandat(objet.id as number).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'mandat_' + name + '.pdf');
                    document.body.appendChild(link);
                    link.click();
                });
            }
        }

        @Watch('loading')
        onLoading() {
            this.sending = this.loading;

            if (!this.loading) {
                this.targetView = 'list';
            }
        }

        get breakpoint(): 'xs' | 'sm' | 'lg' {
            if (this.containerWidth < 600) {
                return 'xs';
            }

            if (this.containerWidth < 900) {
                return 'sm';
            }

            return 'lg';
        }

        created() {
            this.onDefaultValue();
            this.onValue();
        }

        mounted() {
            window.addEventListener('resize', this.onWindowResizeDebounced);
            this.onWindowResize();
        }

        destroyed() {
            window.removeEventListener('resize', this.onWindowResizeDebounced);
        }

        onWindowResize() {
            const $container = this.$refs.container as any;
            const infos = $container.$el.getBoundingClientRect();
            const width = infos.width;

            this.containerWidth = Math.floor(width);
        }



       
fileChangeListener(ev: Event, item: any, asArray: boolean = false) {
        const target = ev.target as HTMLInputElement;
        
        // Vérification que des fichiers ont été sélectionnés
        if (!target.files || target.files.length === 0) {
            return;
        }

        const file = target.files[0];

        // Vérification du type MIME
        if (item.accept && item.accept.split('/')[1] !== '*' && item.accept !== file.type) {
            const $vs = (this as any).$vs;
            const ext = item.accept.split('/')[1];
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur image',
                text: `L'image doit être de format ${ext}`,
            });
            return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);
        
        reader.onloadend = (e: any) => {
            const srcData = e.target.result as string;
            const img = new Image();
            
            img.onload = () => {
                // Dimensions cibles
                const isLogo = (item.name === 'logo');
                const targetW = typeof item.width === 'number' ? item.width : (isLogo ? 200 : 1920);
                const targetH = typeof item.height === 'number' ? item.height : (isLogo ? 100 : 1080);

                // Création du canvas
                const canvas = document.createElement('canvas');
                canvas.width = targetW;
                canvas.height = targetH;
                const ctx = canvas.getContext('2d');
                
                if (!ctx) {
                    console.error('Impossible de récupérer le contexte 2D du canvas');
                    return;
                }

                // Effet "cover" centré
                const ratioSrc = img.width / img.height;
                const ratioDst = targetW / targetH;
                let dw: number, dh: number, dx = 0, dy = 0;

                if (ratioSrc > ratioDst) {
                    dh = targetH;
                    dw = img.width * (targetH / img.height);
                    dx = -(dw - targetW) / 2;
                } else {
                    dw = targetW;
                    dh = img.height * (targetW / img.width);
                    dy = -(dh - targetH) / 2;
                }

                ctx.drawImage(img, dx, dy, dw, dh);

                // Base64 redimensionné
                const resizedData = canvas.toDataURL(file.type);

                // Preview
                this.images = resizedData;

                // Payload pour le backend
                const payload = {
                    name: file.name,
                    file: resizedData,
                    slug: item.slug
                };

                // Affectation selon asArray
                if (asArray) {
                    this.value[item.name] = [payload];
                } else {
                    this.value[item.name] = resizedData;
                }

                // Forcer la mise à jour de Vue
                this.$forceUpdate();
            };
            
            img.onerror = () => {
                const $vs = (this as any).$vs;
                $vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur',
                    text: 'Impossible de charger l\'image',
                });
            };
            
            img.src = srcData;
        };
        
        reader.onerror = () => {
            const $vs = (this as any).$vs;
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: 'Impossible de lire le fichier',
            });
        };
    }








    changeColor(color: string, item: any){
      this.value[item.name] = color;
    }

    customFileChangeListener(ev: Event, item: any) {
        const target = ev.target as HTMLInputElement;

        if (target && target.files) {
            const file: File = target.files[0];

            const myReader: FileReader = new FileReader();
            myReader.readAsDataURL(file);
            myReader.onloadend = (loadEvent: any) => {
                const fileName = file.name;
                const fileContent = loadEvent.target.result;

                this.value[item.fields.name] = fileName;
                this.value[item.fields.content] = fileContent;
            };
        }
    }

    get itemsFiltered() {
        return this.items.filter((item: any) => !item.hidden);
    }

    get sections() {
        const __sectionNames = this.itemsFiltered.map(
            (item: any) => item.section
        );
        const _sectionNames = compact(__sectionNames);
        const sectionNames = uniq(_sectionNames);

        const defaults = this.itemsFiltered.filter(
            (item: any) => !item.section
        );

        const sections = sectionNames.map(section => {
            const items = this.itemsFiltered.filter(
                (item: any) => item.section === section
            );

            const isChunked = items.reduce((accu: boolean, item: any) => {
                if (item.sectionChunked !== undefined) {
                    if (item.sectionChunked === false) {
                    accu = false;
                    }
                }
                return accu;
            }, true);

            return {
                    title: section,
                items: isChunked ? this.itemsChunked(items) : [items],
            };
        });

        return [
            {
                    items: this.itemsChunked(defaults),
            },
            ...sections,
        ];
    }

    itemsChunked(items: any[]) {
        switch (this.breakpoint) {
            case 'xs':
                return [items];
                break;
            case 'sm':
            case 'lg':
                const _size = items.length / 2;
                if(_size > 1){
                    const size = Number.isInteger(_size) ? _size : Math.ceil(_size);
                    const chunks = chunk(items, size);
                        // si address est dans le deuxième tableau on rééquilibre les deux colonnes
                        const addressInChunk1 = chunks[1].find(
                            (item: any) => item.type === 'address'
                        );
                        if (addressInChunk1) {
                            const index = chunks[1].indexOf(addressInChunk1);
                            const sec = Math.min(2, index);
                            const first = take(chunks[1], sec);
                            const last = takeRight(chunks[1], chunks[1].length - sec);

                            chunks[0] = concat(chunks[0], first);
                            chunks[1] = last;
                        }
                    return chunks;
                }else{
                    return [items];
                    break;
                }
        }
    }

    // @Watch('value.address.country', { immediate: true })
    // onCountryChange(newCountry: string) {
    // // Recherche l'item mobile avec le dropdown d'indicatif
    // const mobileItem = this.items.find((item: any) => item.name === 'mobile' && item.withCountryCode);
    // if (mobileItem) {
    //     // Recherche une correspondance dans phoneIndicatives pour le nouveau pays
    //     const matchingIndicative = mobileItem.phoneIndicatives.find((indic: any) =>
    //     indic.value === newCountry || indic.text.toLowerCase() === newCountry.toLowerCase()
    //     );
    //     // Si une correspondance est trouvée, on met à jour, sinon on revient sur +33
    //     this.value[mobileItem.name + '_code'] = matchingIndicative ? matchingIndicative.value : '+33';
    // }
    // }

    // Simplifier la méthode onDefaultValue
    @Watch('defaultValue')
    onDefaultValue(): void {
        this.value = this.defaultValue;
        
        // Traitement des indicatifs téléphoniques
        this.items.forEach((item: any) => {
            // Pour les champs avec indicatif pays
            if (item.withCountryCode) {
                // Si un code d'indicatif est fourni, vérifier s'il correspond à une option disponible
                if (item.phoneIndicatives && item.phoneIndicatives.length > 0 && this.value[item.name + '_code']) {
                    // Trouver le meilleur indicatif correspondant parmi les options disponibles
                    this.value[item.name + '_code'] = this.findMatchingCountryCode(
                        item.phoneIndicatives, 
                        this.value[item.name + '_code']
                    );
                } else if (!this.value[item.name + '_code']) {
                    // Si aucun code n'est fourni, définir la valeur par défaut
                    this.value[item.name + '_code'] = '+33';
                }
            }
        });
    }
    
    @Watch('defaultImages')
    onDefaultImages(): void {
                    this.images = this.defaultImages;
    }
    @Watch('value', {deep: true })
    onValue() {
    this.$emit('getValue', this.value);
    let validtest = true;
    
    // Parcourir tous les items du formulaire
    this.items.forEach((item: any) => {
        // Correction pour le placeholder du select de ant design
        if (item.type === 'select' && this.value[item.name] === null) {
            this.value[item.name] = undefined;
        }

        // Initialisation des objets d'erreur
        if (item.type === 'address') {
            if (!this.error[item.name]) {
                this.error[item.name] = {};
            }
        } else {
            this.error[item.name] = false;
        }

        item.emailMessage = null;
        
        // Validation des objets de type adresse
        if (item.type === 'address') {
            Object.keys(item.fields).forEach(field => {
                const fieldItem = item.fields[field];
                const name = fieldItem.name;
                
                // Vérifie si le champ est requis et s'il est vide
                if (fieldItem.required && isEmpty(this.value[item.name][name])) {
                    this.error[item.name][name] = true;
                    validtest = false;
                    
                    // Message d'erreur personnalisé pour les champs d'adresse
                    if (name === 'country') {
                        fieldItem.errorMessage = 'Le pays est requis';
                    } else if (name === 'city') {
                        fieldItem.errorMessage = 'La ville est requise';
                    } else if (name === 'postal_code') {
                        fieldItem.errorMessage = 'Le code postal est requis';
                    } else if (name === 'street') {
                        fieldItem.errorMessage = 'L\'adresse est requise';
                    }
                } else {
                    this.error[item.name][name] = false;
                }

                if (name === 'country' && fieldItem.component && 
                    this.value[item.name][name] && 
                    !this.isValidCountryValue(this.value[item.name][name], fieldItem)) {
                this.error[item.name][name] = true;
                validtest = false;
                }

            });
        } 
        // Validation des autres types de champs
        else if (item.required && !item.hidden) {
            if (isEmpty(this.value[item.name])) {
                this.error[item.name] = true;
                validtest = false;
                
                // Personnalisation des messages d'erreur selon le type de champ
                if (!item.errorMessage) {
                    if (item.name === 'civility') {
                        item.errorMessage = 'La civilité est requise';
                    } else if (item.name === 'first_lastname') {
                        item.errorMessage = 'Le nom est requis';
                    } else if (item.name === 'first_firstname') {
                        item.errorMessage = 'Le prénom est requis';
                    }
                    // Ajoutez d'autres personnalisations selon les besoins
                }
            } else {
                this.error[item.name] = false;
            }
        }

        // Validation spécifique pour les emails
        if ((item.name === 'email' || item.name === 'email_2') && 
            this.value[item.name] !== '' && 
            this.value[item.name] !== null && 
            !/.+@.+\..+/.test(this.value[item.name])) {
            validtest = false;
            this.error[item.name] = true;
            item.emailMessage = "Ce n'est pas une adresse mail correcte";
        }

        // Validation spécifique pour les numéros de téléphone
        if ((item.name === 'mobile' || item.name === 'mobile_2') && 
            this.value[item.name] !== '' && 
            this.value[item.name] !== null) {
            const cleanedNumber = this.value[item.name].replace(/[\s\-\(\)\.\+]/g, '');
            const validFormat = /^[\d\s\+\-\.\(\)]+$/.test(this.value[item.name]);
            
            if (!validFormat || cleanedNumber.length < 8 || cleanedNumber.length > 15) {
                validtest = false;
                this.error[item.name] = true;
                item.errorMessage = "Ce n'est pas un numéro valide";
            }
        }

        // Validation pour SIREN
        if (this.value[item.name] && item.type == 'siren') {
            const siren = this.value[item.name].replace(/ /g, '');
            if (siren && !/^[0-9]{9}$/.test(siren)) {
                validtest = false;
                this.error[item.name] = true;
                item.errorMessage = "Ce n'est pas un numéro SIREN valide";
            }
        }

        // Validation pour la longueur max des textes
        if (this.value[item.name] && 
            item.type === 'textarea' && 
            item.maxLength && 
            this.value[item.name].length > item.maxLength) {
            validtest = false;
            this.error[item.name] = true;
            item.errorMessage = `Ce champ est limité à ${item.maxLength} caractères`;
        }
    });
    
    // Active l'affichage des erreurs si le formulaire a été soumis
    if (this.isSubmit) {
        this.$forceUpdate(); // Force le rafraîchissement de la vue pour afficher toutes les erreurs
    }
    
    return validtest;
}

    save(name: string): void {
                    this.menu[name] = false;
    }
 

    submit(targetView: TARGET_VIEW = 'list'): void {
    this.isSubmit = true;
    this.valid = true;
    const isValid = this.onValue();
    const hasAddressErrors = Object.values(this.addressErrors || {}).some(error => error === true) || this.hasAddressError;
    
    if (isValid && !hasAddressErrors) {
        this.targetView = targetView;
        
        // Debug: log the values being sent
        console.log('Submitting values:', {
            autonomous: this.value.autonomous,
            website: this.value.website,
            logo: this.value.logo
        });
        
        this.$emit('submit', {
            ...this.value,
            targetView,
        });
    } else {

        
    const $vs = (this as any).$vs;
    
    // Message d'erreur plus spécifique si c'est une erreur de pays
    let errorMessage = 'Veuillez corriger les champs invalides';
    // if (hasAddressErrors) {
    //   errorMessage = 'Le pays sélectionné n\'est pas valide';
    // }
    
    // Défiler jusqu'au premier champ en erreur
    this.$nextTick(() => {
      const firstErrorElement = this.$el.querySelector('.custom-input-error .vs-input--danger');
      if (firstErrorElement) {
        firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
    
    $vs.notify({
      color: 'danger',
      position: 'top-right',
      title: 'Validation',
      text: errorMessage
    });
  }
}

isValidCountryValue(countryValue: string, fieldItem: any): boolean {
  const isValid = fieldItem.items && Array.isArray(fieldItem.items) &&
    fieldItem.items.some((country: any) => 
      country.text.toLowerCase() === countryValue.toLowerCase()
    );
//   console.log("Forms: isValidCountryValue pour", countryValue, "=", isValid);
  return isValid;
}

    getDatePickerFormat(date: string): string | null {
        return date ? new Date(date).toISOString().substr(0, 10) : null;
    }

    getDateFormat(date: string): string | null {
        return date ? moment(date).format('L') : null;
    }

    getNumberDangerMessage(number: string, min: number, max: number) {
        const num = parseInt(number);

        if (min != null && num < min) {
            return `Le nombre doit être supérieur à ${min}`;
        }

        if (max != null && num > max) {
            return `Le nombre doit être inférieur à ${max}`;
        }

        return false;
    }

    handleAddressError(errorInfo: any) {
//   console.log("Forms: handleAddressError appelé avec", errorInfo);
  // Vérifie si errorInfo est un objet
  if (typeof errorInfo === 'object' && errorInfo !== null) {
    // Si c'est un objet avec hasError, traiter comme attendu
    if ('hasError' in errorInfo && 'fieldName' in errorInfo) {
      if (errorInfo.fieldName) {
        this.addressErrors[errorInfo.fieldName] = errorInfo.hasError;
      }
      if (errorInfo.hasError) {
        // Forcer l'invalidation du formulaire immédiatement
        this.valid = false;
        // console.log("Forms: valid mis à false par handleAddressError");
      }
    } else if (typeof errorInfo === 'boolean') {
      // Traitement legacy - boolean simple
      this.hasAddressError = errorInfo;
      if (errorInfo) {
        this.valid = false;
        // console.log("Forms: valid mis à false par handleAddressError (boolean)");
      }
    }
  }
}

    filterOption(input: any, option: any) {
        return (
            option.componentOptions.children[0].text
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
    }

findMatchingCountryCode(phoneIndicatives: any[], code: string): string {
    // Si pas de code passé, on utilise le code par défaut
    if (!code) return '+33';
    
    // Recherche exacte d'abord
    const exactMatch = phoneIndicatives.find((indic: any) => indic.value === code);
    if (exactMatch) return exactMatch.value;
    
    // Recherche par indicatif numérique sans le +
    if (code.startsWith('+')) {
        const numericCode = code.substring(1);
        const numericMatch = phoneIndicatives.find((indic: any) => 
            indic.value.startsWith('+') && indic.value.substring(1) === numericCode
        );
        if (numericMatch) return numericMatch.value;
    }
    
    // Si pas de correspondance exacte, on retourne le code par défaut '+33'
    return '+33';
}

incrementRearMarginRate() {
    if (!this.value.rear_margin_rate) this.value.rear_margin_rate = 0;
    this.value.rear_margin_rate = Math.min(1,
        Math.round((this.value.rear_margin_rate + 0.01) * 100) / 100
    );
    this.onValue(); // Déclencher la validation
}

decrementRearMarginRate() {
    if (!this.value.rear_margin_rate) this.value.rear_margin_rate = 0;
    this.value.rear_margin_rate = Math.max(0,
        Math.round((this.value.rear_margin_rate - 0.01) * 100) / 100
    );
    this.onValue(); // Déclencher la validation
}




deleteImage(item: any) {
    // Réinitialiser complètement la valeur
    this.$set(this.value, item.name, null);
    this.images = null;
    
    // Réinitialiser l'input file si nécessaire
    const fileInput = this.$el.querySelector(`input[name="${item.name}"]`) as HTMLInputElement;
    if (fileInput) {
        fileInput.value = '';
    }
    
    // Forcer la mise à jour
    this.$forceUpdate();
}



}
